import { Stack } from 'expo-router';

export default function DuelLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}>
      <Stack.Screen name="[id]" />
    </Stack>
  );
}
